import {create} from 'zustand';

const useUpdateProfileDetails = create((set) => ({
  isOpen: false,
  open: () => set({isOpen: true}),
  close: () => set({isOpen: false}),
}));


export default useUpdateProfileDetails;